
<template>
  <div
    class="header jobPosingSearch jobPosingSearchJia homeSearch row flexHeader"
    :class="{'font-size-18 jobPosingSearchPC':$store.state.innerWidth>768,'showExtraHeight':showExtra}"
  >
    <div class="warp-mask"></div>
    <div
      class="job-containers job-containersJia col-sm-10 col-md-8 padLeft-0 padRight-0"
      style="width: 1280px !important;"
    >
      <h1
        class="job-contant job-contantJia Bold"
        :class="{'font-size-60':$store.state.innerWidth>768}"
      >{{$t('message.Vacancies Search')}}</h1>
      <div class="job-box" >
        <!--div class="job-countTwo Regular">{{$t('message.Stay')}}</div-->
      </div>
      <div class="search-criteria-w">
        <div class="row search-criteria search-criteriaJia">
          <div class="col-sm-8 col-lg-9 pad-0">
            <div class="row">
              <div class="col-sm-6 pad-10 padRight-35 padLR-20">
                <div class="input-group">
                  <b class="i-left">
                    <i class="icon-search gray" aria-hidden="true"></i>
                  </b>
                  <input
                    type="text"
                    v-model="keyword"
                     maxlength='200'
                    v-bind:placeholder="$t('message.Job title, company name or skill, etc')"
                    class="input-one inputJia"
                    autocomplete="off"
                    @keydown.enter="searchEvent"
                  />
                  <b class="i-right" v-if="keyword" @click="keyword=''">
                    <i class="icon-close-1 gray" aria-hidden="true"></i>
                  </b>
                </div>
              </div>
              <div class="col-sm-6 pad-10 padRight-35 padLR-20" :class="{'show':showJobFunction}">
                <div class="input-group" @click="openJobFunc">
                  <b class="i-left">
                    <i class="icon-box gray" aria-hidden="true"></i>
                  </b>
                  <div class="input-two allInput">
                    <span
                      class="oneline-box"
                      v-if="!jobFunctionDisplay"
                    >{{$t('message.All Job Functions')}}</span>
                    <span class="oneline-box" v-else>{{jobFunctionDisplay}}</span>
                  </div>
                  <b class="i-right">
                    <i class="icon-arrow-down mainColor" aria-hidden="true"></i>
                  </b>
                </div>
                <div
                  class="criteria-content can-scroll multi-layer criteria-job-func show-choice mgRight"
                  :class="{'show':showJobFunction}"
                >
                  <ul>
                    <li class="item-table" v-on:click="selectAllJob()">
                      <div class="tdcell">
                        <!-- {{$store.getters.getContent(jobFunction.title)}} -->
                        {{$t('message.Job Functions')}}
                      </div>
                      <div class="tdcell width-25 text-right">
                        <span class="check-box" :class="selectedAll?'checked':''"></span>
                      </div>
                    </li>
                    <li
                      class="item-table"
                      v-for="(jobFunction,index) in jobFunctions"
                      v-on:click="selectJob(jobFunction)"
                    >
                      <div class="tdcell">{{$store.getters.getContent(jobFunction.title)}}</div>
                      <div class="tdcell width-25 text-right">
                        <span class="check-box" :class="jobFunction.selected?'checked':''"></span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-sm-12 more-options moreOptions SemiBold"
            v-if="needOptions&&$store.state.innerWidth<=768"
          >
            <span class="moreOptions" v-if="!showExtra">
              <span class="pointer" @click="moreEvent">{{$t('message.More Options')}}</span>
            </span>
            <span class="moreOptions" v-if="showExtra">
              <span class="pointer" @click="moreEvent">{{$t('message.Fewer Options')}}</span>
            </span>
          </div>
          <div class="col-sm-4 col-lg-3 moreGroup moreGroupJia pad-0">
            <div class="row">
              <div class="col-xs-12 col-md-12 search-btn search-btnJia pad-10">
                <div class="btn btn-primary" v-on:click="searchEvent()">{{$t('message.Search')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mask" @click="closePopup" :class="{'show':showJobFunction,'maskPC':$store.state.innerWidth>768}"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showJobFunction: false,
      keyword: "",
      jobFunctionIds: "",
      occupationIds: "",
      experience: "",
      isMobile: false,
      showExtra: false,
      showExperience: false,
      jobFunctions: [],
      selectedAll: false,
      jobFunctionDisplay: ""
    };
  },
  props: ["needOptions", "search"],

  components: {},
  methods: {
    openJobFunc: function() {
      this.showExperience = false;
      this.showJobFunction = !this.showJobFunction;
      if (this.comment.getType()) {
        this.isMobile = true;
      }
    },
    moreEvent: function() {
      this.showExtra = !this.showExtra;
    },
    openExperience: function() {
      this.showJobFunction = false;
      this.showExperience = !this.showExperience;
      if (this.comment.getType()) {
        this.isMobile = true;
      }
    },
    searchEvent: function() {
      var that = this;
      this.search({
        keyword: that.keyword,
        jobFunctionIds: that.jobFunctionIds,
        occupationIds: that.occupationIds,
        experience: that.experience
      });
    },
    getJobFunctionList: function() {
      let that = this;
      this.api.getJobFunctionList({}, function(data) {
        that.jobFunctions = data.result.map(function(v, i) {
          v.selected = false;
          return v;
        });
      });
    },
    selectJob: function(job) {
      job.selected = !job.selected;
    },
    selectAllJob: function() {
      let that = this;
      that.selectedAll = !that.selectedAll;
      that.jobFunctions.map(function(v, i) {
        v.selected = that.selectedAll;
        return v;
      });
    },
    closePopup: function() {
      this.showJobFunction = false;
      this.showExperience = false;
    },
    keyDownEvent:function(){

    }
  },
  mounted() {
    this.getJobFunctionList();
        let that = this;
  },
  watch: {
    jobFunctions: {
      handler: function(val, oldval) {
        let that = this;

        //selected job Function
        let selectedJobFunctions = that.jobFunctions.filter(
          jobFunction => jobFunction.selected
        );

        this.selectedAll =
          selectedJobFunctions.length == this.jobFunctions.length;
        if (that.selectedAll) {
          this.jobFunctionDisplay = this.$i18n.t("message.Job Functions");
        } else {
          this.jobFunctionDisplay = selectedJobFunctions
            .map(function(v, i) {
              return that.$store.getters.getContent(v.title);
            })
            .join(","); //title , title
        }
        this.jobFunctionIds = selectedJobFunctions
          .map(function(v, i) {
            return v.id;
          })
          .join(",");
      },
      deep: true
    }
  }
};
</script>
